import { useRef as o } from "react";

function t(e) {
  return [e.screenX, e.screenY];
}

function u() {
  var e = o([-1, -1]);
  return {
    wasMoved: function wasMoved(r) {
      var n = t(r);
      return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
    },
    update: function update(r) {
      e.current = t(r);
    }
  };
}

export { u as useTrackedPointer };